import { WhatMakesUsDifferentSingleComponentProps } from "./WhatMakesUsDifferent";

import { MdOutlineRocketLaunch } from "react-icons/md";
import { ImCross } from "react-icons/im";
import { BsFileBarGraphFill } from "react-icons/bs";
import { IoSparklesOutline } from "react-icons/io5";
import { TbTruckDelivery } from "react-icons/tb";
import { BsCashStack } from "react-icons/bs";

export const forCoords: WhatMakesUsDifferentSingleComponentProps[] = [
  {
    icon: <MdOutlineRocketLaunch />,
    header: "Easy Setup",
    subText: "Launch your fundraiser in minutes with simple guided steps.",
  },
  {
    icon: <ImCross />,
    header: "No Paperwork",
    subText:
      "Say goodbye to forms and spreadsheets - everything is managed online",
  },
  {
    icon: <BsFileBarGraphFill />,
    header: "Real-Time Tracking",
    subText:
      "Monitor donations and progress sales as they come in, all in one dashboard.",
  },
  {
    icon: <TbTruckDelivery />,
    header: "No Delivery",
    subText: "Don't deal with melted chocolates or cookie dough!",
  },
  {
    icon: <BsCashStack />,
    header: "Great Payouts",
    subText: "We offer 40% - 80% on all fundraisers! No minimums!",
  },
  {
    icon: <IoSparklesOutline />,
    header: "Custom Branding",
    subText:
      "Personalize your fundraiser with your team's name, colors, and story.",
  },
];

export default forCoords;
